<template>
  <div class="view">
    <Title title="イベント(クローズド)"/>
    <quizset-main />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import QuizsetMain from '@/components/EventClosed/QuizsetMain'

export default {
  components: {
    Title,
    QuizsetMain
  }
}
</script>
